"use client";

import React, { Suspense, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Navbar } from '@/components/Navbar';
import Footer from '@/components/Footer';
import CostEstimator from '@/components/cost-estimator/CostEstimator';
import { SHOW_PRICING } from '@/lib/feature-flags';

export default function EstimatePage() {
  const router = useRouter();

  useEffect(() => {
    if (!SHOW_PRICING) {
      router.replace('/book');
    }
  }, [router]);

  if (!SHOW_PRICING) {
    return null; // Avoid flicker before redirect
  }

  return (
    <div className="flex flex-col min-h-screen bg-bloom-cream">
      <Navbar />
      <main className="flex-grow pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <header className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-[2px] bg-bloom-gold" />
              <span className="font-sans text-xs font-bold uppercase tracking-widest text-bloom-gold">
                Investment
              </span>
            </div>
            <h1 className="heading-hero text-bloom-charcoal mb-4">Project Cost Estimator</h1>
            <p className="font-sans text-lg text-bloom-muted max-w-2xl leading-relaxed">
              Answer 5 quick questions to get an instant, honest ballpark estimate for your nonprofit or community project. No email required to see results.
            </p>
          </header>

          <section 
            className="bg-white rounded-[2.5rem] border border-bloom-border p-8 md:p-12 shadow-sm relative overflow-hidden"
            aria-label="Interactive cost estimator"
          >
            <Suspense fallback={<div className="min-h-[400px] flex items-center justify-center font-sans text-bloom-muted italic">Initializating estimator...</div>}>
              <CostEstimator />
            </Suspense>
          </section>

          <footer className="mt-12 text-center">
            <p className="font-sans text-sm text-bloom-muted italic">
              * Ballpark estimates are for planning purposes. Final proposals are provided after a direct discovery call.
            </p>
          </footer>
        </div>
      </main>
      <Footer />
    </div>
  );
}
